export const DELETION_REASONS = [
  { value: "no_longer_using", label: "No longer using Spacelift" },
  { value: "migrating", label: "Migrating to another platform" },
  { value: "discontinued", label: "Project or company discontinued" },
  { value: "evaluation_complete", label: "Testing or evaluation complete" },
  { value: "other", label: "Other (please specify below)" },
];
